'use client';

import React from 'react';
import { Button } from '@skin-seoul/design-system';
interface BuyNowButtonProps {
  onClick: () => void;
  size?: 'mobile' | 'desktop';
  productStatus?: string;
  hasSelectedOption?: boolean;
}
const BuyNowButton = ({
  onClick,
  size = 'desktop',
  productStatus,
  hasSelectedOption = true
}: BuyNowButtonProps) => {
  const isMobile = size === 'mobile';
  const isDisabled = productStatus === 'outofstock' || !hasSelectedOption;
  return <Button width="100%" height={isMobile ? '44px' : {
    base: '44px',
    tablet: '48px'
  }} backgroundColor={isDisabled ? 'neutral.100' : 'primary.600'} color={isDisabled ? 'neutral.400' : 'white'} borderRadius="8px" textStyle={isMobile ? 'label.medium' : {
    base: 'label.medium',
    tablet: 'label.large'
  }} fontWeight="normal" justifyContent="center" _hover={{
    backgroundColor: 'primary.700'
  }} onClick={onClick} disabled={isDisabled} data-sentry-element="Button" data-sentry-component="BuyNowButton" data-sentry-source-file="BuyNowButton.tsx">
      {productStatus === 'outofstock' ? 'Currently Unavailable' : 'Buy Now'}
    </Button>;
};
export default BuyNowButton;